import * as Stimulus from "@hotwired/stimulus"

export class FrameDialogController extends Stimulus.Controller {
    static get targets() {
        return [ 'dialog', 'frame' ];
    }

    connect() {
        this.initialFrameMarkup = this.frameTarget.innerHTML;
        this.handleFrameInput = this.handleFrameInput.bind(this);
        this.frameTarget.addEventListener('input', this.handleFrameInput);
        this.resetDirtyState();
    }

    disconnect() {
        this.frameTarget.removeEventListener('input', this.handleFrameInput);
    }

    open() {
        this.resetDirtyState();
        if(!this.dialogTarget.open) {
            this.dialogTarget.showModal();
        }
    }

    close(e) {
        if(e) {
            e.preventDefault();
        }
        if(this.dialogTarget.open) {
            this.dialogTarget.close();
        }
        this.resetFrame();
    }

    closeIfClickedOutside(e) {
        if(e.target == this.dialogTarget && this.dialogTarget.open) {
            if(this.hasTypedInTextarea && !window.confirm('You have unsaved changes to these notes. Close without saving?')) {
                return;
            }
            this.close();
        }
    }

    closeOnSuccess(e) {
        if(e.detail.success) {
            this.close();
        }
    }

    focusAutofocusElement() {
        const $autofocus = this.frameTarget.querySelector('[autofocus]');
        if($autofocus) {
            $autofocus.focus();
        }
    }

    handleFrameInput(e) {
        if(e.target instanceof HTMLTextAreaElement) {
            this.hasTypedInTextarea = true;
        }
    }

    resetDirtyState() {
        this.hasTypedInTextarea = false;
    }

    resetFrame() {
        this.resetDirtyState();
        this.frameTarget.innerHTML = this.initialFrameMarkup;
        this.frameTarget.removeAttribute('src');
    }
}
